import { EventEmitter, Injectable, Output } from '@angular/core';
import { AbstractControl, AsyncValidator, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { InfoFromCisloUjDto } from '../dto/InfoFromCisloUjDto';
import { FillFormService } from '../services/fill-form.service';
import { UjParseUtils } from '../Utils/uj.parse.utils';

@Injectable({
  providedIn: 'root'
})
export class UjAsyncValidator implements AsyncValidator {

  constructor(
    private fillFormService: FillFormService,
    private ujParseUtils: UjParseUtils
  ) { }

  @Output() ujInfoEvent: EventEmitter<InfoFromCisloUjDto> = new EventEmitter<InfoFromCisloUjDto>();

  validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    return this._valid(control);
  }

  /**
   * Metoda pro nastavení validátoru pomocí setAsyncValidators
   * @param control
   */
  validateFn(control: AbstractControl): AsyncValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
      return this._valid(control);
    };
  }

  private _valid(control: AbstractControl): Observable<ValidationErrors | null> {
    let ujInfo: InfoFromCisloUjDto = this.ujParseUtils.parseUj(control.value);
    if (ujInfo.isValidCzCisloUj) {
      return this.fillFormService.getPlatnaUj(control.value)
        .pipe(
          map(resp => {
            if (resp == void 0) {
              this.ujInfoEvent.emit(null);
              return { 'ujError': 'Uznaná jednotka není platná.' };
            }
            else {
              ujInfo.puvodKod = resp?.puvodKod;
              ujInfo.puvodPlo = resp?.puvodPlo;
              this.ujInfoEvent.emit(ujInfo);
              return null;
            }
          })
        );
    }
    else {
      this.ujInfoEvent.emit(null);
      return of({ 'ujError': 'Uznaná jednotka není validní.' });
    }
  }
}
